"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GeometryType = _interopRequireDefault(require("../../geom/GeometryType.js"));

var _VectorContext = _interopRequireDefault(require("../VectorContext.js"));

var _colorlike = require("../../colorlike.js");

var _transform = require("../../transform.js");

var _canvas = require("../canvas.js");

var _array = require("../../array.js");

var _extent = require("../../extent.js");

var _transform2 = require("../../geom/flat/transform.js");

var _SimpleGeometry = require("../../geom/SimpleGeometry.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/render/canvas/Immediate
 */
// FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext~VectorContext VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */
var CanvasImmediateRenderer =
/** @class */
function (_super) {
  __extends(CanvasImmediateRenderer, _super);
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {number} [opt_squaredTolerance] Optional squared tolerance for simplification.
   * @param {import("../../proj.js").TransformFunction} [opt_userTransform] Transform from user to view projection.
   */


  function CanvasImmediateRenderer(context, pixelRatio, extent, transform, viewRotation, opt_squaredTolerance, opt_userTransform) {
    var _this = _super.call(this) || this;
    /**
     * @private
     * @type {CanvasRenderingContext2D}
     */


    _this.context_ = context;
    /**
     * @private
     * @type {number}
     */

    _this.pixelRatio_ = pixelRatio;
    /**
     * @private
     * @type {import("../../extent.js").Extent}
     */

    _this.extent_ = extent;
    /**
     * @private
     * @type {import("../../transform.js").Transform}
     */

    _this.transform_ = transform;
    /**
     * @private
     * @type {number}
     */

    _this.viewRotation_ = viewRotation;
    /**
     * @private
     * @type {number}
     */

    _this.squaredTolerance_ = opt_squaredTolerance;
    /**
     * @private
     * @type {import("../../proj.js").TransformFunction}
     */

    _this.userTransform_ = opt_userTransform;
    /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */

    _this.contextFillState_ = null;
    /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */

    _this.contextStrokeState_ = null;
    /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */

    _this.contextTextState_ = null;
    /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */

    _this.fillState_ = null;
    /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */

    _this.strokeState_ = null;
    /**
     * @private
     * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
     */

    _this.image_ = null;
    /**
     * @private
     * @type {number}
     */

    _this.imageAnchorX_ = 0;
    /**
     * @private
     * @type {number}
     */

    _this.imageAnchorY_ = 0;
    /**
     * @private
     * @type {number}
     */

    _this.imageHeight_ = 0;
    /**
     * @private
     * @type {number}
     */

    _this.imageOpacity_ = 0;
    /**
     * @private
     * @type {number}
     */

    _this.imageOriginX_ = 0;
    /**
     * @private
     * @type {number}
     */

    _this.imageOriginY_ = 0;
    /**
     * @private
     * @type {boolean}
     */

    _this.imageRotateWithView_ = false;
    /**
     * @private
     * @type {number}
     */

    _this.imageRotation_ = 0;
    /**
     * @private
     * @type {import("../../size.js").Size}
     */

    _this.imageScale_ = [0, 0];
    /**
     * @private
     * @type {number}
     */

    _this.imageWidth_ = 0;
    /**
     * @private
     * @type {string}
     */

    _this.text_ = '';
    /**
     * @private
     * @type {number}
     */

    _this.textOffsetX_ = 0;
    /**
     * @private
     * @type {number}
     */

    _this.textOffsetY_ = 0;
    /**
     * @private
     * @type {boolean}
     */

    _this.textRotateWithView_ = false;
    /**
     * @private
     * @type {number}
     */

    _this.textRotation_ = 0;
    /**
     * @private
     * @type {import("../../size.js").Size}
     */

    _this.textScale_ = [0, 0];
    /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */

    _this.textFillState_ = null;
    /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */

    _this.textStrokeState_ = null;
    /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */

    _this.textState_ = null;
    /**
     * @private
     * @type {Array<number>}
     */

    _this.pixelCoordinates_ = [];
    /**
     * @private
     * @type {import("../../transform.js").Transform}
     */

    _this.tmpLocalTransform_ = (0, _transform.create)();
    return _this;
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */


  CanvasImmediateRenderer.prototype.drawImages_ = function (flatCoordinates, offset, end, stride) {
    if (!this.image_) {
      return;
    }

    var pixelCoordinates = (0, _transform2.transform2D)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
    var context = this.context_;
    var localTransform = this.tmpLocalTransform_;
    var alpha = context.globalAlpha;

    if (this.imageOpacity_ != 1) {
      context.globalAlpha = alpha * this.imageOpacity_;
    }

    var rotation = this.imageRotation_;

    if (this.imageRotateWithView_) {
      rotation += this.viewRotation_;
    }

    for (var i = 0, ii = pixelCoordinates.length; i < ii; i += 2) {
      var x = pixelCoordinates[i] - this.imageAnchorX_;
      var y = pixelCoordinates[i + 1] - this.imageAnchorY_;

      if (rotation !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
        var centerX = x + this.imageAnchorX_;
        var centerY = y + this.imageAnchorY_;
        (0, _transform.compose)(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
        context.setTransform.apply(context, localTransform);
        context.translate(centerX, centerY);
        context.scale(this.imageScale_[0], this.imageScale_[1]);
        context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
        context.setTransform(1, 0, 0, 1, 0, 0);
      } else {
        context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
      }
    }

    if (this.imageOpacity_ != 1) {
      context.globalAlpha = alpha;
    }
  };
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */


  CanvasImmediateRenderer.prototype.drawText_ = function (flatCoordinates, offset, end, stride) {
    if (!this.textState_ || this.text_ === '') {
      return;
    }

    if (this.textFillState_) {
      this.setContextFillState_(this.textFillState_);
    }

    if (this.textStrokeState_) {
      this.setContextStrokeState_(this.textStrokeState_);
    }

    this.setContextTextState_(this.textState_);
    var pixelCoordinates = (0, _transform2.transform2D)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
    var context = this.context_;
    var rotation = this.textRotation_;

    if (this.textRotateWithView_) {
      rotation += this.viewRotation_;
    }

    for (; offset < end; offset += stride) {
      var x = pixelCoordinates[offset] + this.textOffsetX_;
      var y = pixelCoordinates[offset + 1] + this.textOffsetY_;

      if (rotation !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1) {
        var localTransform = (0, _transform.compose)(this.tmpLocalTransform_, x, y, 1, 1, rotation, -x, -y);
        context.setTransform.apply(context, localTransform);
        context.translate(x, y);
        context.scale(this.textScale_[0], this.textScale_[1]);

        if (this.textStrokeState_) {
          context.strokeText(this.text_, 0, 0);
        }

        if (this.textFillState_) {
          context.fillText(this.text_, 0, 0);
        }

        context.setTransform(1, 0, 0, 1, 0, 0);
      } else {
        if (this.textStrokeState_) {
          context.strokeText(this.text_, x, y);
        }

        if (this.textFillState_) {
          context.fillText(this.text_, x, y);
        }
      }
    }
  };
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @private
   * @return {number} end End.
   */


  CanvasImmediateRenderer.prototype.moveToLineTo_ = function (flatCoordinates, offset, end, stride, close) {
    var context = this.context_;
    var pixelCoordinates = (0, _transform2.transform2D)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
    context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
    var length = pixelCoordinates.length;

    if (close) {
      length -= 2;
    }

    for (var i = 2; i < length; i += 2) {
      context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
    }

    if (close) {
      context.closePath();
    }

    return end;
  };
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */


  CanvasImmediateRenderer.prototype.drawRings_ = function (flatCoordinates, offset, ends, stride) {
    for (var i = 0, ii = ends.length; i < ii; ++i) {
      offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true);
    }

    return offset;
  };
  /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @api
   */


  CanvasImmediateRenderer.prototype.drawCircle = function (geometry) {
    if (!(0, _extent.intersects)(this.extent_, geometry.getExtent())) {
      return;
    }

    if (this.fillState_ || this.strokeState_) {
      if (this.fillState_) {
        this.setContextFillState_(this.fillState_);
      }

      if (this.strokeState_) {
        this.setContextStrokeState_(this.strokeState_);
      }

      var pixelCoordinates = (0, _SimpleGeometry.transformGeom2D)(geometry, this.transform_, this.pixelCoordinates_);
      var dx = pixelCoordinates[2] - pixelCoordinates[0];
      var dy = pixelCoordinates[3] - pixelCoordinates[1];
      var radius = Math.sqrt(dx * dx + dy * dy);
      var context = this.context_;
      context.beginPath();
      context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);

      if (this.fillState_) {
        context.fill();
      }

      if (this.strokeState_) {
        context.stroke();
      }
    }

    if (this.text_ !== '') {
      this.drawText_(geometry.getCenter(), 0, 2, 2);
    }
  };
  /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @api
   */


  CanvasImmediateRenderer.prototype.setStyle = function (style) {
    this.setFillStrokeStyle(style.getFill(), style.getStroke());
    this.setImageStyle(style.getImage());
    this.setTextStyle(style.getText());
  };
  /**
   * @param {import("../../transform.js").Transform} transform Transform.
   */


  CanvasImmediateRenderer.prototype.setTransform = function (transform) {
    this.transform_ = transform;
  };
  /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @api
   */


  CanvasImmediateRenderer.prototype.drawGeometry = function (geometry) {
    var type = geometry.getType();

    switch (type) {
      case _GeometryType["default"].POINT:
        this.drawPoint(
        /** @type {import("../../geom/Point.js").default} */
        geometry);
        break;

      case _GeometryType["default"].LINE_STRING:
        this.drawLineString(
        /** @type {import("../../geom/LineString.js").default} */
        geometry);
        break;

      case _GeometryType["default"].POLYGON:
        this.drawPolygon(
        /** @type {import("../../geom/Polygon.js").default} */
        geometry);
        break;

      case _GeometryType["default"].MULTI_POINT:
        this.drawMultiPoint(
        /** @type {import("../../geom/MultiPoint.js").default} */
        geometry);
        break;

      case _GeometryType["default"].MULTI_LINE_STRING:
        this.drawMultiLineString(
        /** @type {import("../../geom/MultiLineString.js").default} */
        geometry);
        break;

      case _GeometryType["default"].MULTI_POLYGON:
        this.drawMultiPolygon(
        /** @type {import("../../geom/MultiPolygon.js").default} */
        geometry);
        break;

      case _GeometryType["default"].GEOMETRY_COLLECTION:
        this.drawGeometryCollection(
        /** @type {import("../../geom/GeometryCollection.js").default} */
        geometry);
        break;

      case _GeometryType["default"].CIRCLE:
        this.drawCircle(
        /** @type {import("../../geom/Circle.js").default} */
        geometry);
        break;

      default:
    }
  };
  /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @api
   */


  CanvasImmediateRenderer.prototype.drawFeature = function (feature, style) {
    var geometry = style.getGeometryFunction()(feature);

    if (!geometry || !(0, _extent.intersects)(this.extent_, geometry.getExtent())) {
      return;
    }

    this.setStyle(style);
    this.drawGeometry(geometry);
  };
  /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   */


  CanvasImmediateRenderer.prototype.drawGeometryCollection = function (geometry) {
    var geometries = geometry.getGeometriesArray();

    for (var i = 0, ii = geometries.length; i < ii; ++i) {
      this.drawGeometry(geometries[i]);
    }
  };
  /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   */


  CanvasImmediateRenderer.prototype.drawPoint = function (geometry) {
    if (this.squaredTolerance_) {
      geometry =
      /** @type {import("../../geom/Point.js").default} */
      geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
    }

    var flatCoordinates = geometry.getFlatCoordinates();
    var stride = geometry.getStride();

    if (this.image_) {
      this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
    }

    if (this.text_ !== '') {
      this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
  };
  /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   */


  CanvasImmediateRenderer.prototype.drawMultiPoint = function (geometry) {
    if (this.squaredTolerance_) {
      geometry =
      /** @type {import("../../geom/MultiPoint.js").default} */
      geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
    }

    var flatCoordinates = geometry.getFlatCoordinates();
    var stride = geometry.getStride();

    if (this.image_) {
      this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
    }

    if (this.text_ !== '') {
      this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
  };
  /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   */


  CanvasImmediateRenderer.prototype.drawLineString = function (geometry) {
    if (this.squaredTolerance_) {
      geometry =
      /** @type {import("../../geom/LineString.js").default} */
      geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
    }

    if (!(0, _extent.intersects)(this.extent_, geometry.getExtent())) {
      return;
    }

    if (this.strokeState_) {
      this.setContextStrokeState_(this.strokeState_);
      var context = this.context_;
      var flatCoordinates = geometry.getFlatCoordinates();
      context.beginPath();
      this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false);
      context.stroke();
    }

    if (this.text_ !== '') {
      var flatMidpoint = geometry.getFlatMidpoint();
      this.drawText_(flatMidpoint, 0, 2, 2);
    }
  };
  /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   */


  CanvasImmediateRenderer.prototype.drawMultiLineString = function (geometry) {
    if (this.squaredTolerance_) {
      geometry =
      /** @type {import("../../geom/MultiLineString.js").default} */
      geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
    }

    var geometryExtent = geometry.getExtent();

    if (!(0, _extent.intersects)(this.extent_, geometryExtent)) {
      return;
    }

    if (this.strokeState_) {
      this.setContextStrokeState_(this.strokeState_);
      var context = this.context_;
      var flatCoordinates = geometry.getFlatCoordinates();
      var offset = 0;
      var ends =
      /** @type {Array<number>} */
      geometry.getEnds();
      var stride = geometry.getStride();
      context.beginPath();

      for (var i = 0, ii = ends.length; i < ii; ++i) {
        offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false);
      }

      context.stroke();
    }

    if (this.text_ !== '') {
      var flatMidpoints = geometry.getFlatMidpoints();
      this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
    }
  };
  /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   */


  CanvasImmediateRenderer.prototype.drawPolygon = function (geometry) {
    if (this.squaredTolerance_) {
      geometry =
      /** @type {import("../../geom/Polygon.js").default} */
      geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
    }

    if (!(0, _extent.intersects)(this.extent_, geometry.getExtent())) {
      return;
    }

    if (this.strokeState_ || this.fillState_) {
      if (this.fillState_) {
        this.setContextFillState_(this.fillState_);
      }

      if (this.strokeState_) {
        this.setContextStrokeState_(this.strokeState_);
      }

      var context = this.context_;
      context.beginPath();
      this.drawRings_(geometry.getOrientedFlatCoordinates(), 0,
      /** @type {Array<number>} */
      geometry.getEnds(), geometry.getStride());

      if (this.fillState_) {
        context.fill();
      }

      if (this.strokeState_) {
        context.stroke();
      }
    }

    if (this.text_ !== '') {
      var flatInteriorPoint = geometry.getFlatInteriorPoint();
      this.drawText_(flatInteriorPoint, 0, 2, 2);
    }
  };
  /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   */


  CanvasImmediateRenderer.prototype.drawMultiPolygon = function (geometry) {
    if (this.squaredTolerance_) {
      geometry =
      /** @type {import("../../geom/MultiPolygon.js").default} */
      geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
    }

    if (!(0, _extent.intersects)(this.extent_, geometry.getExtent())) {
      return;
    }

    if (this.strokeState_ || this.fillState_) {
      if (this.fillState_) {
        this.setContextFillState_(this.fillState_);
      }

      if (this.strokeState_) {
        this.setContextStrokeState_(this.strokeState_);
      }

      var context = this.context_;
      var flatCoordinates = geometry.getOrientedFlatCoordinates();
      var offset = 0;
      var endss = geometry.getEndss();
      var stride = geometry.getStride();
      context.beginPath();

      for (var i = 0, ii = endss.length; i < ii; ++i) {
        var ends = endss[i];
        offset = this.drawRings_(flatCoordinates, offset, ends, stride);
      }

      if (this.fillState_) {
        context.fill();
      }

      if (this.strokeState_) {
        context.stroke();
      }
    }

    if (this.text_ !== '') {
      var flatInteriorPoints = geometry.getFlatInteriorPoints();
      this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
    }
  };
  /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */


  CanvasImmediateRenderer.prototype.setContextFillState_ = function (fillState) {
    var context = this.context_;
    var contextFillState = this.contextFillState_;

    if (!contextFillState) {
      context.fillStyle = fillState.fillStyle;
      this.contextFillState_ = {
        fillStyle: fillState.fillStyle
      };
    } else {
      if (contextFillState.fillStyle != fillState.fillStyle) {
        contextFillState.fillStyle = fillState.fillStyle;
        context.fillStyle = fillState.fillStyle;
      }
    }
  };
  /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */


  CanvasImmediateRenderer.prototype.setContextStrokeState_ = function (strokeState) {
    var context = this.context_;
    var contextStrokeState = this.contextStrokeState_;

    if (!contextStrokeState) {
      context.lineCap = strokeState.lineCap;

      if (context.setLineDash) {
        context.setLineDash(strokeState.lineDash);
        context.lineDashOffset = strokeState.lineDashOffset;
      }

      context.lineJoin = strokeState.lineJoin;
      context.lineWidth = strokeState.lineWidth;
      context.miterLimit = strokeState.miterLimit;
      context.strokeStyle = strokeState.strokeStyle;
      this.contextStrokeState_ = {
        lineCap: strokeState.lineCap,
        lineDash: strokeState.lineDash,
        lineDashOffset: strokeState.lineDashOffset,
        lineJoin: strokeState.lineJoin,
        lineWidth: strokeState.lineWidth,
        miterLimit: strokeState.miterLimit,
        strokeStyle: strokeState.strokeStyle
      };
    } else {
      if (contextStrokeState.lineCap != strokeState.lineCap) {
        contextStrokeState.lineCap = strokeState.lineCap;
        context.lineCap = strokeState.lineCap;
      }

      if (context.setLineDash) {
        if (!(0, _array.equals)(contextStrokeState.lineDash, strokeState.lineDash)) {
          context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
        }

        if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
          contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
          context.lineDashOffset = strokeState.lineDashOffset;
        }
      }

      if (contextStrokeState.lineJoin != strokeState.lineJoin) {
        contextStrokeState.lineJoin = strokeState.lineJoin;
        context.lineJoin = strokeState.lineJoin;
      }

      if (contextStrokeState.lineWidth != strokeState.lineWidth) {
        contextStrokeState.lineWidth = strokeState.lineWidth;
        context.lineWidth = strokeState.lineWidth;
      }

      if (contextStrokeState.miterLimit != strokeState.miterLimit) {
        contextStrokeState.miterLimit = strokeState.miterLimit;
        context.miterLimit = strokeState.miterLimit;
      }

      if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
        contextStrokeState.strokeStyle = strokeState.strokeStyle;
        context.strokeStyle = strokeState.strokeStyle;
      }
    }
  };
  /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */


  CanvasImmediateRenderer.prototype.setContextTextState_ = function (textState) {
    var context = this.context_;
    var contextTextState = this.contextTextState_;
    var textAlign = textState.textAlign ? textState.textAlign : _canvas.defaultTextAlign;

    if (!contextTextState) {
      context.font = textState.font;
      context.textAlign =
      /** @type {CanvasTextAlign} */
      textAlign;
      context.textBaseline =
      /** @type {CanvasTextBaseline} */
      textState.textBaseline;
      this.contextTextState_ = {
        font: textState.font,
        textAlign: textAlign,
        textBaseline: textState.textBaseline
      };
    } else {
      if (contextTextState.font != textState.font) {
        contextTextState.font = textState.font;
        context.font = textState.font;
      }

      if (contextTextState.textAlign != textAlign) {
        contextTextState.textAlign =
        /** @type {CanvasTextAlign} */
        textAlign;
        context.textAlign =
        /** @type {CanvasTextAlign} */
        textAlign;
      }

      if (contextTextState.textBaseline != textState.textBaseline) {
        contextTextState.textBaseline =
        /** @type {CanvasTextBaseline} */
        textState.textBaseline;
        context.textBaseline =
        /** @type {CanvasTextBaseline} */
        textState.textBaseline;
      }
    }
  };
  /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   */


  CanvasImmediateRenderer.prototype.setFillStrokeStyle = function (fillStyle, strokeStyle) {
    var _this = this;

    if (!fillStyle) {
      this.fillState_ = null;
    } else {
      var fillStyleColor = fillStyle.getColor();
      this.fillState_ = {
        fillStyle: (0, _colorlike.asColorLike)(fillStyleColor ? fillStyleColor : _canvas.defaultFillStyle)
      };
    }

    if (!strokeStyle) {
      this.strokeState_ = null;
    } else {
      var strokeStyleColor = strokeStyle.getColor();
      var strokeStyleLineCap = strokeStyle.getLineCap();
      var strokeStyleLineDash = strokeStyle.getLineDash();
      var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
      var strokeStyleLineJoin = strokeStyle.getLineJoin();
      var strokeStyleWidth = strokeStyle.getWidth();
      var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
      var lineDash = strokeStyleLineDash ? strokeStyleLineDash : _canvas.defaultLineDash;
      this.strokeState_ = {
        lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : _canvas.defaultLineCap,
        lineDash: this.pixelRatio_ === 1 ? lineDash : lineDash.map(function (n) {
          return n * _this.pixelRatio_;
        }),
        lineDashOffset: (strokeStyleLineDashOffset ? strokeStyleLineDashOffset : _canvas.defaultLineDashOffset) * this.pixelRatio_,
        lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : _canvas.defaultLineJoin,
        lineWidth: (strokeStyleWidth !== undefined ? strokeStyleWidth : _canvas.defaultLineWidth) * this.pixelRatio_,
        miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : _canvas.defaultMiterLimit,
        strokeStyle: (0, _colorlike.asColorLike)(strokeStyleColor ? strokeStyleColor : _canvas.defaultStrokeStyle)
      };
    }
  };
  /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   */


  CanvasImmediateRenderer.prototype.setImageStyle = function (imageStyle) {
    var imageSize;

    if (!imageStyle || !(imageSize = imageStyle.getSize())) {
      this.image_ = null;
      return;
    }

    var imageAnchor = imageStyle.getAnchor();
    var imageOrigin = imageStyle.getOrigin();
    this.image_ = imageStyle.getImage(this.pixelRatio_);
    this.imageAnchorX_ = imageAnchor[0] * this.pixelRatio_;
    this.imageAnchorY_ = imageAnchor[1] * this.pixelRatio_;
    this.imageHeight_ = imageSize[1] * this.pixelRatio_;
    this.imageOpacity_ = imageStyle.getOpacity();
    this.imageOriginX_ = imageOrigin[0];
    this.imageOriginY_ = imageOrigin[1];
    this.imageRotateWithView_ = imageStyle.getRotateWithView();
    this.imageRotation_ = imageStyle.getRotation();
    this.imageScale_ = imageStyle.getScaleArray();
    this.imageWidth_ = imageSize[0] * this.pixelRatio_;
  };
  /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   */


  CanvasImmediateRenderer.prototype.setTextStyle = function (textStyle) {
    if (!textStyle) {
      this.text_ = '';
    } else {
      var textFillStyle = textStyle.getFill();

      if (!textFillStyle) {
        this.textFillState_ = null;
      } else {
        var textFillStyleColor = textFillStyle.getColor();
        this.textFillState_ = {
          fillStyle: (0, _colorlike.asColorLike)(textFillStyleColor ? textFillStyleColor : _canvas.defaultFillStyle)
        };
      }

      var textStrokeStyle = textStyle.getStroke();

      if (!textStrokeStyle) {
        this.textStrokeState_ = null;
      } else {
        var textStrokeStyleColor = textStrokeStyle.getColor();
        var textStrokeStyleLineCap = textStrokeStyle.getLineCap();
        var textStrokeStyleLineDash = textStrokeStyle.getLineDash();
        var textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
        var textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
        var textStrokeStyleWidth = textStrokeStyle.getWidth();
        var textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
        this.textStrokeState_ = {
          lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : _canvas.defaultLineCap,
          lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : _canvas.defaultLineDash,
          lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : _canvas.defaultLineDashOffset,
          lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : _canvas.defaultLineJoin,
          lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : _canvas.defaultLineWidth,
          miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : _canvas.defaultMiterLimit,
          strokeStyle: (0, _colorlike.asColorLike)(textStrokeStyleColor ? textStrokeStyleColor : _canvas.defaultStrokeStyle)
        };
      }

      var textFont = textStyle.getFont();
      var textOffsetX = textStyle.getOffsetX();
      var textOffsetY = textStyle.getOffsetY();
      var textRotateWithView = textStyle.getRotateWithView();
      var textRotation = textStyle.getRotation();
      var textScale = textStyle.getScaleArray();
      var textText = textStyle.getText();
      var textTextAlign = textStyle.getTextAlign();
      var textTextBaseline = textStyle.getTextBaseline();
      this.textState_ = {
        font: textFont !== undefined ? textFont : _canvas.defaultFont,
        textAlign: textTextAlign !== undefined ? textTextAlign : _canvas.defaultTextAlign,
        textBaseline: textTextBaseline !== undefined ? textTextBaseline : _canvas.defaultTextBaseline
      };
      this.text_ = textText !== undefined ? Array.isArray(textText) ? textText.reduce(function (acc, t, i) {
        return acc += i % 2 ? ' ' : t;
      }, '') : textText : '';
      this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
      this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
      this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
      this.textRotation_ = textRotation !== undefined ? textRotation : 0;
      this.textScale_ = [this.pixelRatio_ * textScale[0], this.pixelRatio_ * textScale[1]];
    }
  };

  return CanvasImmediateRenderer;
}(_VectorContext["default"]);

var _default = CanvasImmediateRenderer;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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